export default __webpack_public_path__ + "static/media/jazy.2c56d658.png";